import React, { createContext, useCallback, useState, useContext } from 'react';

import api from '~/services/api';

import { AuthState, AuthContextData } from './interface';

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setData] = useState<AuthState>(() => {
    const user = localStorage.getItem('@commerceplus_auth:token');

    if (user) {
      const { perfil, token, idloja, identificadorloja } = JSON.parse(user);
      api.defaults.headers.common.Token = `${token}`;
      api.defaults.headers.common.Idl = `${idloja}`;
      const conta = idloja;
      return { perfil, token, idloja, identificadorloja, conta };
    }
    return {} as AuthState;
  });

  const signIn = useCallback(async (user: AuthState) => {
    const { perfil, token, idloja, identificadorloja } = user;
    localStorage.setItem('@commerceplus_auth:token', JSON.stringify(user));
    api.defaults.headers.common.Token = `${token}`;
    api.defaults.headers.common.Idl = `${idloja}`;
    const conta = idloja;
    setData({ perfil, token, idloja, identificadorloja, conta });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@commerceplus_auth:token');
    setData({} as AuthState);
    window.location.href =
      'https://commerceplus.info/auth/#/login?next=https://commerceplus.info/apps/appgestor&app=7';
  }, []);

  return (
    <AuthContext.Provider value={{ user, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('hook usada fora de contexto de autenticação!');
  }
  return context;
}
